module.exports = __webpack_public_path__ + "static/img/a.6378776.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jeu2/img/a.png
// module id = QCO9
// module chunks = 0